export const apiName: string = 'planos-manutencoes';
export const planosRoute: string = 'planos';
export const planosStorage: string = 'planos';
export const planosModuleName: any = {plural: 'Planos de manutenção', single: 'Plano de manutenção'};

export const referenciaTempo: any[] = [
    {Key: 1, Value: 'Dia(s)'},
    {Key: 7, Value: 'Semana(s)'},
    {Key: 30, Value: 'Mes(es)'},
    {Key: 365, Value: 'Ano(s)'}
];

export const planoQuery: any = {
    "where":{
        "and": [
            {"ativo":true},
            {"titulo":{"regexp":"/REPLACEHERE/i"}}
        ]
    },
    "include":["marca","categoria"],
    "order":"titulo"
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/shared/data.service.ts
 **/